import classNames from 'classnames';
import { flatten } from 'lodash';
import React, { useEffect, useRef, useState } from 'react';
import { Popover } from '@meitu/saas-ui';
import { MaterialIdsType } from '@meitu/saas-editor-core/es/version-types';
import IconFont from '@meitu/xdesign-icon-font';
import { useLocaleStore } from '@/i18n';
import { editor } from '@/instance';
import { fetchTextAnimationMaterial } from '@/services/material';
import TextAnimationList, { type TextAnimationMaterial } from './text-animation-list';

type Props = {
    layerId: string;
};

const TextAnimationEntry: React.FC<Props> = ({ layerId }) => {
    const { $t } = useLocaleStore();
    const popoverRef = useRef<any>(null);
    const [open, setOpen] = useState<boolean>(false);
    const [material, setMaterial] = useState<TextAnimationMaterial | null>(null);
    const [textAnimationMaterialList, setTextAnimationMaterialList] = useState<TextAnimationMaterial[]>([]);
    const layer = editor.services.flatLayer.getLayer(layerId);
    const getData = async () => {
        const res = await Promise.all([
            fetchTextAnimationMaterial('vesdk_text_animation_opening'),
            fetchTextAnimationMaterial('vesdk_text_animation_ending'),
            fetchTextAnimationMaterial('vesdk_text_animation_loop'),
        ]);
        const data = res.map((item) => {
            return item.data.response.materials;
        });
        setTextAnimationMaterialList(flatten(data));
    };
    useEffect(() => {
        getData();
    }, []);
    useEffect(() => {
        if (layer) {
            const materialId = layer.materialIds?.[MaterialIdsType.TEXT_ANIMATION]?.[0];
            if (materialId) {
                const material = textAnimationMaterialList.find((item) => item.id + '' === materialId);
                setMaterial(material || null);
            }
        }
    }, [layer, textAnimationMaterialList]);
    return (
        <div className="sub-panel-entry">
            <Popover
                trigger="click"
                ref={popoverRef}
                content={
                    <TextAnimationList
                        textAnimationMaterialList={textAnimationMaterialList}
                        layerId={layerId}
                        onClose={() => popoverRef.current?.onClick?.()}
                        onClick={(material) => {
                            setMaterial(material);
                        }}
                    />
                }
                placement="left"
                overlayClassName="text-layer-panel-popover"
                destroyTooltipOnHide
                onOpenChange={(val) => setOpen(val)}
            >
                <div className={classNames('sub-panel-entry__content', { 'sub-panel-entry__content--open': open })}>
                    <div className="sub-panel-entry__thumbnail">
                        {material ? (
                            <img src={material.thumbnail.url} alt="material" />
                        ) : (
                            <IconFont name="SlashCircleBold" fontSize={28} color="rgba(171, 173, 178, 1)" />
                        )}
                    </div>
                    <div className="sub-panel-entry__title">文字动效</div>
                    <IconFont name={open ? 'ChevronUpBlack' : 'ChevronDownBlack'} fontSize={12} />
                </div>
            </Popover>
        </div>
    );
};

export default React.memo(TextAnimationEntry);
